import React from 'react';
import GettingHereTemplate from '../../components/GettingHere/GettingHereTemplate';

const GettingHerePatagonia: React.FC = () => {
  const patagoniaProps = {
    variant: 'patagonia' as const,
    heroTitle: 'Getting to Awasi Patagonia',
    heroDescription: 'From Santiago, Chile: LATAM and SKY Airlines fly to Puerto Natales or Punta Arenas. From Buenos Aires: LATAM and AEROLÍNEAS ARGENTINAS fly to Calafate. Awasi will suggest different alternatives for the transfer by land from Punta Arenas or Calafate to our hotel.',
    heroImage: '/assets/images/localhost/b511fc05b56f6f56ab808fe346dacf0108ddd079.png',
    mapConfig: {
      center: { lat: -50.9423, lng: -73.4068 }, // Torres del Paine coordinates
      zoom: 10,
      markerPosition: { lat: -50.9423, lng: -73.4068 }
    },
    locationInfo: {
      title: 'Getting to Awasi Patagonia',
      address: '3rd Km. of the road from Torres del Paine to Cerro Castillo, Villa Cerro Castillo, Torres del Paine, Chile',
      directions: [
        {
          title: 'FROM SANTIAGO DE CHILE',
          description: 'Fly to Puerto Natales (PNT) / 120 km / 2:00 hs from Awasi or TO Punta Arenas (PUQ) / 350 km / 4:00 hs from Awasi. Awasi includes private transfers from and to Puerto Natales or the Cerro Castillo border, in accordance to our check in & check out times. Our team can suggest different alternatives for transfers from other places.'
        }
      ],
      nearbyBorders: [
        { country: 'ARGENTINA', border: 'Cerro Castillo (55 km)', distance: 'Driving time to El Calafate airport: 5 hours' }
      ]
    },
    transferInfo: 'Awasi includes private transfers from and to Puerto Natales or the Cerro Castillo border, in accordance to our check in & check out times.',
    showGoogleMap: true
  };

  return <GettingHereTemplate {...patagoniaProps} />;
};

export default GettingHerePatagonia;